import { Button, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { selectedDayType } from "../../utils/types";

export const DaySelection = ({
  selectedDays,
  setSelectedDays,
  windowSize = 1000,
  preselectToday = false,
  preselectCurrentWeek = false,
  setAvailableDays,
  showWeekNavigation = false,
}: {
  selectedDays;
  setSelectedDays;
  windowSize?: number;
  preselectToday?: boolean;
  preselectCurrentWeek?: boolean;
  setAvailableDays?: (days: selectedDayType[]) => void;
  showWeekNavigation?: boolean;
}) => {
  const [nextDays, setNextDays] = useState<selectedDayType[]>([]);
  const [weekOffset, setWeekOffset] = useState(0);

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    day: selectedDayType,
  ) => {
    if (event.target.checked) {
      setSelectedDays([...selectedDays, day]);
    } else {
      setSelectedDays(selectedDays.filter((d) => d !== day));
    }
  };

  // set next days
  const getNextWorkdays = (currentDate: moment.Moment, windowSize) => {
    const nextWorkdays: {
      days: moment.Moment[];
      abbr: string;
    }[] = [];
    // Funktion zur Ermittlung der Anzahl der auszuwählenden Tage
    // Anforderung: "Ab Donnerstag soll für alle User Termine bis folgenden Freitag selektierbar sein"
    const calculateDaysToShow = (weekday: number): number => {
      switch (weekday) {
        case 1:
          return 7; // Montag: zeige bis Sonntag (7 Tage)
        case 2:
          return 6; // Dienstag: zeige bis Sonntag (6 Tage)
        case 3:
          return 5; // Mittwoch: zeige bis Sonntag (5 Tage)
        case 4:
          return 9; // Donnerstag: zeige bis zum Fr der Folgewoche (9 Tage)
        case 5:
          return 8; // Freitag: zeige bis zum Fr der Folgewoche (8 Tage)
        case 6:
          return 7; // Samstag: zeige bis zum Fr der Folgewoche (7 Tage)
        case 7:
          return 6; // Sonntag: zeige bis zum Fr der Folgewoche (6 Tage)
        default:
          return 5;
      }
    };

    let daysToShow = calculateDaysToShow(currentDate.isoWeekday());
    // const lastWeek = {
    //   abbr: "Letzte Woche",
    //   days: [],
    // };
    // for (let i = 7; i > 0; i--) {
    //   lastWeek.days.push(currentDate.clone().subtract(i, "days"));
    // }
    // nextWorkdays.push(lastWeek);
    if (currentDate.isoWeekday() <= 50) {
      //vorher 5 (Werktage)
      nextWorkdays.push({
        abbr: "Heute",
        days: [currentDate.clone()],
      });
    }
    while (nextWorkdays.length < daysToShow) {
      currentDate = currentDate.add(1, "day");
      if (currentDate.isoWeekday() <= 50) {
        //vorher 5 (Werktage)
        let newAbbr = currentDate
          .format("dd")
          .replace("Tu", "Di")
          .replace("We", "Mi")
          .replace("Th", "Do")
          .replace("Su", "So");
        if (windowSize >= 700) newAbbr += " " + currentDate.format("DD.MM.");
        nextWorkdays.push({
          abbr: newAbbr,
          days: [currentDate.clone()],
        });
      }
    }
    // const nextWeek = {
    //   abbr: "Nächste Woche",
    //   days: [],
    // };
    // for (let i = 1; i <= 7; i++) {
    //   nextWeek.days.push(currentDate.clone().add(i, "days"));
    // }
    // nextWorkdays.push(nextWeek);
    setNextDays(nextWorkdays);
    if (setAvailableDays) {
      setAvailableDays(nextWorkdays);
    }
  };

  useEffect(() => {
    const currentDate = moment().startOf("day").add(weekOffset, "weeks");
    getNextWorkdays(currentDate, windowSize);
  }, [weekOffset]);

  useEffect(() => {
    if (preselectToday && nextDays?.filter((day) => day.abbr === "Heute")[0])
      setSelectedDays([
        ...selectedDays,
        nextDays?.filter((day) => day.abbr === "Heute")[0],
      ]);
    if (
      preselectCurrentWeek &&
      nextDays?.filter(
        (day) => day.abbr !== "Letzte Woche" && day.abbr !== "Nächste Woche",
      )
    )
      setSelectedDays([
        ...selectedDays,
        ...nextDays?.filter(
          (day) => day.abbr !== "Letzte Woche" && day.abbr !== "Nächste Woche",
        ),
      ]);
  }, [nextDays]);

  const renderWeekNavigation = () => {
    if (!showWeekNavigation) return null;
    return (
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px", gap: "10px" }}>
        <Button onClick={() => setWeekOffset(weekOffset - 1)} variant="outlined" style={{ borderRadius: "20px" }}>
          Vorherige Woche
        </Button>
        {weekOffset !== 0 && (
          <Button onClick={() => setWeekOffset(0)} variant="outlined" style={{ borderRadius: "20px" }}>
            Heute
          </Button>
        )}
        <Button onClick={() => setWeekOffset(weekOffset + 1)} variant="outlined" style={{ borderRadius: "20px" }}>
          Nächste Woche
        </Button>
      </div>
    );
  };

  if (windowSize < 700) {
    return (
      <>
        {renderWeekNavigation()}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FormGroup aria-label="position" row>
            {nextDays &&
              nextDays
                .filter(
                  (day) =>
                    day.abbr !== "Nächste Woche" && day.abbr !== "Letzte Woche",
                )
                .map((day, index) => (
                  <FormControlLabel
                    key={day.days[0].format("DD.MM.YYYY")}
                    value="top"
                    control={
                      <Checkbox
                        checked={selectedDays.includes(day)}
                        onChange={(event) => {
                          if (event.target.checked) {
                            setSelectedDays([day]);
                          } else {
                            setSelectedDays([]);
                          }
                        }}
                      />
                    }
                    label={day.abbr}
                    labelPlacement="top"
                    style={{ margin: 8 }}
                  />
                ))}
          </FormGroup>{" "}
        </div>
        {/* <div style={{ display: "flex", justifyContent: "center" }}>
          <FormGroup aria-label="position" row>
            {nextDays &&
              nextDays
                .filter(
                  (day) =>
                    day.abbr === "Nächste Woche" || day.abbr === "Letzte Woche"
                )
                .map((day, index) => (
                  <FormControlLabel
                    key={day.days[0].format("DD.MM.YYYY")}
                    value="top"
                    control={
                      <Checkbox
                        onChange={(event) => handleCheckboxChange(event, day)}
                        defaultChecked={
                          (day.abbr === "Heute" && preselectToday) ||
                          (day.abbr !== "Nächste Woche" &&
                            day.abbr !== "Letzte Woche" &&
                            preselectCurrentWeek)
                        }
                      />
                    }
                    label={day.abbr}
                    labelPlacement="top"
                    style={{ margin: 8 }}
                  />
                ))}
          </FormGroup>
        </div> */}
      </>
    );
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      {renderWeekNavigation()}
      <FormGroup aria-label="position" row>
        {nextDays &&
          nextDays.map((day, index) => (
            <FormControlLabel
              key={day.days[0].format("DD.MM.YYYY")}
              value="top"
              control={
                <Checkbox
                  checked={selectedDays.includes(day)}
                  onChange={(event) => {
                    if (event.target.checked) {
                      setSelectedDays([day]);
                    } else {
                      setSelectedDays([]);
                    }
                  }}
                />
              }
              label={day.abbr}
              labelPlacement="top"
              style={{ margin: 8 }}
            />
          ))}
      </FormGroup>{" "}
    </div>
  );
};
